import { render } from "./SimpleTextItem0.vue?vue&type=template&id=af92ec48&scoped=true&ts=true"
import script from "./SimpleTextItem0.vue?vue&type=script&lang=ts"
export * from "./SimpleTextItem0.vue?vue&type=script&lang=ts"

import "./SimpleTextItem0.vue?vue&type=style&index=0&id=af92ec48&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af92ec48"]])

export default __exports__